import Swal from 'sweetalert2';

/*
 * Reasons attached to an attendance record, shown on demand rather than in the
 * row: the employee's own reason for a Late or Half Day (employeeNote), and the
 * reason given with a short leave request (shortLeaveReason). They are separate
 * fields, and separate from `note`, which the system rewrites on every punch.
 */

const hasShortLeaveReason = (log) =>
    Boolean(log?.shortLeaveReason && log.shortLeaveStatus && log.shortLeaveStatus !== 'None');

export const hasAttendanceReasons = (log) => Boolean(log?.employeeNote) || hasShortLeaveReason(log);

export const employeeReasonLabel = (log) =>
    log?.status === 'Late' ? 'Reason for arriving late'
        : log?.status === 'Half Day' ? 'Reason for the half day'
            : 'Reason given by the employee';

// Built as DOM nodes so the text is never parsed as HTML.
const section = (label, text) => {
    const wrap = document.createElement('div');
    wrap.className = 'att-reason-block';
    const heading = document.createElement('div');
    heading.className = 'att-reason-label';
    heading.textContent = label;
    const body = document.createElement('div');
    body.className = 'att-reason-body';
    body.textContent = text;
    wrap.append(heading, body);
    return wrap;
};

/** Read-only popup with whichever reasons the record has. */
export const showAttendanceReasons = (log) => {
    const content = document.createElement('div');
    content.className = 'att-reason-popup';
    if (log.employeeNote) content.append(section(employeeReasonLabel(log), log.employeeNote));
    if (hasShortLeaveReason(log)) {
        content.append(section(`Short leave reason (${log.shortLeaveStatus.toLowerCase()})`, log.shortLeaveReason));
    }
    return Swal.fire({
        title: log.userId?.name ? `${log.userId.name} · ${log.date}` : log.date,
        html: content,
        confirmButtonText: 'Close',
        confirmButtonColor: '#215D7B'
    });
};
